import { z } from 'zod';

export const RoleSchema = z.enum(['Admin', 'Team Lead', 'Annotator', 'QA']);

export const PersonSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().email(),
  roles: z.array(RoleSchema),
});
export type Person = z.infer<typeof PersonSchema>;

export const EmploymentInformationSchema = z.object({
  start_date: z.string().optional(),
});
export type EmploymentInformation = z.infer<typeof EmploymentInformationSchema>;

export const UserSchema = z.object({
  user_id: z.string(),
  okta_id: z.string().optional().nullable(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().email(),
  status: z.string(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  last_login: z.coerce.date().nullable(),
  organization: z.string().nullable(),
  second_email: z.string().email().nullable(),
  user_type: z.string().nullable(),
  start_date: z.coerce.date().optional().nullable(),
  roles: z.array(RoleSchema),
  contract_start_date: z.coerce.date().nullable().optional(),
  contract_end_date: z.coerce.date().nullable().optional(),
  contract_id: z.string().nullable().optional(),
  tags: z.string(),
  user_manager_id: z.string().nullable().optional(),
  user_manager: z
    .object({
      user_id: z.string(),
      first_name: z.string(),
      last_name: z.string(),
      email: z.string().email(),
    })
    .nullable()
    .optional(),
  permissions: z
    .string()
    .optional()
    .transform((val) => val ?? ''),
});
export type User = z.infer<typeof UserSchema>;

export const UserMetadataSchema = UserSchema.pick({
  user_id: true,
  okta_id: true,
  status: true,
  start_date: true,
  created_at: true,
  updated_at: true,
  last_login: true,
  organization: true,
  second_email: true,
  user_type: true,
});
export type UserMetadata = z.infer<typeof UserMetadataSchema>;

export const NewUserSchema = PersonSchema.pick({
  first_name: true,
  last_name: true,
  email: true,
  roles: true,
});
export type NewUser = z.infer<typeof NewUserSchema>;

export const UserHistorySchema = z.object({
  history_id: z.number(),
  user_id: z.string(),
  operation_type: z.string(),
  change_timestamp: z.coerce.date(),
  user_prev_data: UserSchema.partial().extend({
    roles: z.array(z.string()).optional(),
  }),
});
export type UserHistory = z.infer<typeof UserHistorySchema>;
